import { searchConstants } from "./search-constants";

const searchSubmit = (keyword) => async (dispatch) => {
  dispatch({
    type: searchConstants.SEARCH_SUBMIT_START,
    payload: keyword,
  }); 
};

const searchShowAction = (show) => async (dispatch) => {
  dispatch({
    type: searchConstants.SEARCH_SHOW_START,
    payload: show,
  });
};

const searchSupportCall = (data) => async (dispatch) => {
  dispatch({
    type: searchConstants.SEARCH_SUPPORT_CALL,
    data: data,
  });
};

export { searchSubmit, searchShowAction, searchSupportCall };
